import { useQuery } from "react-query";
import { useSearchParams } from "react-router-dom";
import { useApiAccess } from "./useApiAccess";
import { getSubcategories } from "../../Service/CategoryService";
import { queryKeys } from "./queryKeys";

export function useSubCategories({ categorySlug }) {
  const hasAccess = useApiAccess();
  const [searchParams] = useSearchParams();
  const productParam = searchParams.get("product");

  const pathParams = { ...(productParam && { product: productParam }) };

  return useQuery(
    queryKeys.subCategories(categorySlug, productParam),
    () => getSubcategories({ categorySlug }, pathParams),
    { enabled: !!hasAccess && !!categorySlug }
  );
}
